import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; 
import { 
    Box, Button, Container, Card, CardContent, Typography, Stack, Grid, FormControlLabel, Radio, RadioGroup
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";

const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: "none", fontWeight: 700 } } }
    }
});

const getStationsMT = (day) => {
    switch(day) {
        case 0: return [{id: 'khho', name: 'Khánh Hòa'}, {id: 'kotu', name: 'Kon Tum'}, {id: 'thth', name: 'Thừa Thiên Huế'}];
        case 1: return [{id: 'phye', name: 'Phú Yên'}, {id: 'thth', name: 'Thừa Thiên Huế'}];
        case 2: return [{id: 'dalak', name: 'Đắk Lắk'}, {id: 'quna', name: 'Quảng Nam'}];
        case 3: return [{id: 'dana', name: 'Đà Nẵng'}, {id: 'khho', name: 'Khánh Hòa'}];
        case 4: return [{id: 'bidi', name: 'Bình Định'}, {id: 'qubi', name: 'Quảng Bình'}, {id: 'qutr', name: 'Quảng Trị'}];
        case 5: return [{id: 'gila', name: 'Gia Lai'}, {id: 'nith', name: 'Ninh Thuận'}];
        case 6: return [{id: 'dana', name: 'Đà Nẵng'}, {id: 'dano', name: 'Đắk Nông'}, {id: 'qung', name: 'Quảng Ngãi'}];
        default: return [];
    }
};

const getStationsMN = (day) => {
    switch(day) {
        case 0: return [{id: 'dalat', name: 'Đà Lạt'}, {id: 'kigi', name: 'Kiên Giang'}, {id: 'tigi', name: 'Tiền Giang'}];
        case 1: return [{id: 'cama', name: 'Cà Mau'}, {id: 'doth', name: 'Đồng Tháp'}, {id: 'tphc', name: 'TP. HCM'}];
        case 2: return [{id: 'bali', name: 'Bạc Liêu'}, {id: 'vuta', name: 'Vũng Tàu'}, {id: 'betr', name: 'Bến Tre'}];
        case 3: return [{id: 'cath', name: 'Cần Thơ'}, {id: 'dona', name: 'Đồng Nai'}, {id: 'sotr', name: 'Sóc Trăng'}];
        case 4: return [{id: 'angi', name: 'An Giang'}, {id: 'bith', name: 'Bình Thuận'}, {id: 'tani', name: 'Tây Ninh'}];
        case 5: return [{id: 'bidu', name: 'Bình Dương'}, {id: 'trvi', name: 'Trà Vinh'}, {id: 'vilo', name: 'Vĩnh Long'}];
        case 6: return [{id: 'biph', name: 'Bình Phước'}, {id: 'hagi', name: 'Hậu Giang'}, {id: 'loan', name: 'Long An'}, {id: 'tphc', name: 'TP. HCM'}];
        default: return [];
    }
};

function AdminCustomLottery() {
    const API_URL = "https://server.df999.mom/api/custom-lottery";
    const getTodayStr = () => new Date().toISOString().split('T')[0];
    
    const [allData, setAllData] = useState({});
    const [selectedDate, setSelectedDate] = useState(getTodayStr());
    const [selectedRegion, setSelectedRegion] = useState("mb");
    const [selectedDai, setSelectedDai] = useState("");
    
    // Chỉ lưu 3 mảng của AI
    const [aiData, setAiData] = useState({ ai_2so: "", ai_3so: "", ai_4so: "" });
    
    const [availableStations, setAvailableStations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchAllData = async () => {
        try {
            const res = await axios.get(API_URL);
            if (res.data.success) setAllData(res.data.data);
        } catch (error) {
            swal("Lỗi", "Không thể kết nối đến Server", "error");
        }
    };

    useEffect(() => { fetchAllData(); }, []);

    useEffect(() => {
        if (selectedRegion === 'mb') {
            setAvailableStations([]);
            setSelectedDai("");
        } else {
            const dayOfWeek = new Date(selectedDate).getDay();
            let stations = selectedRegion === 'mt' ? getStationsMT(dayOfWeek) : getStationsMN(dayOfWeek);
            setAvailableStations(stations);
            if (stations.length > 0 && !stations.find(s => s.id === selectedDai)) setSelectedDai(stations[0].id);
        }
    }, [selectedDate, selectedRegion]);

    // Trích xuất đúng dữ liệu AI
    useEffect(() => {
        if (!allData[selectedDate] || !allData[selectedDate].ai) {
            return setAiData({ ai_2so: "", ai_3so: "", ai_4so: "" });
        }

        const dailyAI = allData[selectedDate].ai;
        let currentAi = null;

        if (selectedRegion === 'mb') currentAi = dailyAI.mb;
        else if (selectedRegion === 'mt') currentAi = dailyAI.mt?.[selectedDai];
        else if (selectedRegion === 'mn') currentAi = dailyAI.mn?.[selectedDai];

        if (currentAi) {
            setAiData({
                ai_2so: currentAi.ai_2so?.join(", ") || "",
                ai_3so: currentAi.ai_3so?.join(", ") || "",
                ai_4so: currentAi.ai_4so?.join(", ") || ""
            });
        } else {
            setAiData({ ai_2so: "", ai_3so: "", ai_4so: "" });
        }
    }, [selectedDate, selectedRegion, selectedDai, allData]);

    const handleInputChange = (e) => {
        setAiData({ ...aiData, [e.target.name]: e.target.value });
    };

    const handleGenerate = async () => {
        if (selectedRegion !== 'mb' && !selectedDai) return swal("Cảnh báo", "Vui lòng chọn đài", "warning");
        setIsLoading(true);
        try {
            const res = await axios.post(`${API_URL}/generate`);
            if (res.data.success) {
                const { ai_2so, ai_3so, ai_4so } = res.data.result;
                setAiData({ ai_2so: ai_2so.join(", "), ai_3so: ai_3so.join(", "), ai_4so: ai_4so.join(", ") });
            }
        } catch (error) {
            swal("Lỗi", "Mất kết nối Server", "error");
        }
        setIsLoading(false);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!aiData.ai_2so || !aiData.ai_3so || !aiData.ai_4so) {
            return swal("Cảnh báo", "Vui lòng điền đủ số cho Bot AI", "warning");
        }
        setIsLoading(true);
        try {
            const res = await axios.post(`${API_URL}/update`, {
                date: selectedDate,
                region: selectedRegion,
                dai: selectedDai,
                ai_2so: aiData.ai_2so.split(",").map(s => s.trim()).filter(Boolean),
                ai_3so: aiData.ai_3so.split(",").map(s => s.trim()).filter(Boolean),
                ai_4so: aiData.ai_4so.split(",").map(s => s.trim()).filter(Boolean)
            });
            if (res.data.success) {
                fetchAllData();
                swal("Thành công", "Đã lưu số cho Bot AI!", "success");
            }
        } catch (error) {
            swal("Lỗi", "Mất kết nối Server", "error");
        }
        setIsLoading(false);
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .admin-zone * { box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; }
                        .custom-input { width: 100%; padding: 10px 14px; border: 1px solid #E4E6EF; border-radius: 6px; font-weight: 600; color: #1B84FF; outline: none; background-color: #F9F9F9; font-size: 15px; letter-spacing: 1px; }
                        .custom-input:focus { border-color: #1B84FF; background-color: #FFF; box-shadow: 0 0 0 3px rgba(27, 132, 255, 0.1); }
                    `}</style>
                    <Box className="admin-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        <Container maxWidth="md">
                            <Box mb={4} display="flex" justifyContent="space-between" alignItems="center">
                                <Box>
                                    <Typography variant="h4" fontWeight="800" color="#181C32">BOT AI</Typography>
                                </Box>
                                <Button variant="outlined" color="primary" onClick={fetchAllData} sx={{ borderRadius: '6px', backgroundColor: '#FFF' }}>
                                    Tải lại dữ liệu
                                </Button>
                            </Box>

                            <Card sx={{ backgroundColor: '#FFFFFF', mb: 3 }}>
                                <CardContent sx={{ p: {xs: 3, sm: 4} }}>
                                    <form onSubmit={handleSave}>
                                        <Grid container spacing={3} mb={3} alignItems="center">
                                            <Grid item xs={12} md={4}>
                                                <Typography variant="subtitle2" fontWeight="700" color="#3F4254" mb={1} textAlign="center">Chọn Ngày</Typography>
                                                <input type="date" className="custom-input" style={{color: '#181C32', letterSpacing: 0}} value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
                                            </Grid>
                                            <Grid item xs={12} md={selectedRegion === 'mb' ? 8 : 4} display="flex" flexDirection="column" alignItems="center">
                                                <Typography variant="subtitle2" fontWeight="700" color="#3F4254" mb={1}>Chọn Miền</Typography>
                                                <RadioGroup row value={selectedRegion} onChange={(e) => setSelectedRegion(e.target.value)}>
                                                    <FormControlLabel value="mb" control={<Radio color="primary" />} label={<Typography fontWeight="600">Miền Bắc</Typography>} />
                                                    <FormControlLabel value="mt" control={<Radio color="primary" />} label={<Typography fontWeight="600">Miền Trung</Typography>} />
                                                    <FormControlLabel value="mn" control={<Radio color="primary" />} label={<Typography fontWeight="600">Miền Nam</Typography>} />
                                                </RadioGroup>
                                            </Grid>
                                            {selectedRegion !== 'mb' && (
                                                <Grid item xs={12} md={4}>
                                                    <Typography variant="subtitle2" fontWeight="700" color="#3F4254" mb={1} textAlign="center">Chọn Đài</Typography>
                                                    <select className="custom-input" style={{color: '#181C32', letterSpacing: 0}} value={selectedDai} onChange={(e) => setSelectedDai(e.target.value)}>
                                                        {availableStations.length === 0 && <option value="">Hôm nay không có đài nào</option>}
                                                        {availableStations.map(station => ( <option key={station.id} value={station.id}>{station.name} ({station.id})</option> ))}
                                                    </select>
                                                </Grid>
                                            )}
                                        </Grid>

                                        <Box sx={{ border: '1px solid #EFF2F5', borderRadius: '12px', overflow: 'hidden', mb: 4 }}>
                                            <Box sx={{ p: 2, backgroundColor: '#F1FAFF', textAlign: 'center', borderBottom: '1px solid #EFF2F5' }}>
                                                <Typography variant="subtitle1" fontWeight="800" color="#009EF7">🤖 DỮ LIỆU DỰ ĐOÁN (CÁCH NHAU DẤU PHẨY)</Typography>
                                            </Box>
                                            <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                <Box>
                                                    <Typography variant="subtitle2" fontWeight="700" mb={1}>Lô 2 Số</Typography>
                                                    <input className="custom-input" name="ai_2so" value={aiData.ai_2so} onChange={handleInputChange} placeholder="VD: 08, 68, 86" />
                                                </Box>
                                                <Box>
                                                    <Typography variant="subtitle2" fontWeight="700" mb={1}>3 Càng</Typography>
                                                    <input className="custom-input" name="ai_3so" value={aiData.ai_3so} onChange={handleInputChange} placeholder="VD: 108, 368, 886" />
                                                </Box>
                                                <Box>
                                                    <Typography variant="subtitle2" fontWeight="700" mb={1}>4 Càng</Typography>
                                                    <input className="custom-input" name="ai_4so" value={aiData.ai_4so} onChange={handleInputChange} placeholder="VD: 0108, 0368, 0886" />
                                                </Box>
                                            </Box>
                                        </Box>

                                        <Stack direction="row" spacing={2} justifyContent="center">
                                            <Button type="button" variant="outlined" color="warning" onClick={handleGenerate} disabled={isLoading} sx={{ borderRadius: '6px', px: 4 }}>
                                                Tạo Ngẫu Nhiên
                                            </Button>
                                            <Button type="submit" variant="contained" color="success" disabled={isLoading} sx={{ borderRadius: '6px', px: 6, boxShadow: 'none' }}>
                                                Lưu Kết Quả
                                            </Button>
                                        </Stack>
                                    </form>
                                </CardContent>
                            </Card>
                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default AdminCustomLottery;